export default __webpack_public_path__ + "static/highlanderpro-9567bc2fb76455f2b177fa93af6878f1.png";